import React from 'react'
import listloader from "../assets/images/listloader.svg";

const Listing = ({ListComponent, fetching, error, data, ...restProps}) => {
    if (error) return <ErrorBox errmsg="Something went wrong" />;
    if (fetching) return <ListLoader />;
    if (data.length  === 0 ) return <ErrorBox errmsg="No Data Found" />;
    return data.map(item => <ListComponent {...restProps} {...item} key={item.id}  />)
}

export const ListLoader = () => (
    <div className="flex-center">
        <img src={listloader} style={{height: `40px`}} alt="" />
    </div>
)

export const ErrorBox = ({errmsg=""}) => (
    <div style={{padding: `5px`, marginBottom: `10px`, color: 'red', border: `1px solid red`}}>
        { errmsg }
    </div>
)

export default Listing
